enum NavCompaniesFormPage {
  GENRAL_DATA = '1',
  ADDRESS = '2'
}

export default NavCompaniesFormPage;
